<template>

    <SubHeader title="Fiche agent" :breads="[{ name: 'Créer Agent' }]" :action="{}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="prepareUpdate" >

                <div class="row">
                    <div class="col-md-6">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="firstname">Prénom(s)</label>
                                    <input type="text" name="firstname" id="firstname" class="form-control"
                                        placeholder="Prénom(s)" v-model="agentShowItems.firstname" value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="lastname">Nom</label>
                                    <input type="text" name="lastname" id="lastname" class="form-control"
                                        placeholder="Nom" v-model="agentShowItems.lastname" value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="email">Email</label>
                                    <input type="text" name="email" v-model="agentShowItems.email" id="email" class="form-control" placeholder="Email"
                                        value="">
                                </div>
                                <div class="mb-3">
                                    <label class="form-label" for="contact">Contact</label>
                                    <input type="text" name="contact" id="contact" class="form-control"
                                        placeholder="contact" v-model="agentShowItems.contact" value="">
                                </div>
                                <div class="mb-3 tom-select-custom">
                                    <label class="form-label" for="service">Service</label>
                                    <m-select v-model="agentShowItems.recipientservice" :loading="serviceIsLoading"  :required="true" :options="serviceItems" :searchable="false" 
                                        placeholder="Type de service" track-by="id" label="label" >
                                    </m-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Modifier</button>&nbsp;
                                <button type="button" class="btn btn-danger" @click="this.$router.back()">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigShowAgent",
    components: {
        SubHeader
    },
    data() {
        return {
            dataAccept: ["id","recipientservice","firstname","lastname","email","contact"],
        }
    },

    computed: {
        ...mapFields("agent/update", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            isUpdated:"isUpdated"

        }),
        ...mapFields("service/list", {
            serviceIsLoading: "isLoading",
            serviceIsSuccess: "isSuccess",
            serviceShowMessage: "showMessage",
            serviceMessage: "message",
            serviceItems: "items"

        }),
        ...mapFields("agent/show", {
            agenteShowIsLoading: "isLoading",
            agenteShowIsSuccess: "isSuccess",
            agenteShowShowMessage: "showMessage",
            agenteShowMessage: "message",
            agentShowItems: "item"

        })
    },

    methods: {
        ...mapActions({
            handleSubmit: "agent/update/update",
            reset: "agent/update/resetData",
            getServices: "service/list/getAll",
            getCurrentAgente:"agent/show/getOne"
        }),
        prepareUpdate(){
            var backData = {}
            this.dataAccept.forEach(it => {
                if("recipientservice" == it ){
                    backData["recipientservice_id"]  = this.agentShowItems[it]?.id ?? null
                    
                } else{
                    backData[it]  = this.agentShowItems[it]
                }
            });
            this.handleSubmit(backData)

        }
    },
    watch:{
        
        isUpdated(val){
            if(val){
                this.$router.push({name:'AdminConfigAgent'})
            }
        }
    },

    unmounted() {
        this.reset()
    },
    mounted() {
        
        this.getCurrentAgente(this.$route.params.id)
        this.getServices()
    }
}
</script>
